import { lazy, Suspense, useEffect, useState } from 'react';
import Index from "./jsx";
import { connect, useDispatch } from 'react-redux';
import { Navigate, Route, Routes, useLocation, useNavigate, useParams } from 'react-router-dom';
import { checkAutoLogin } from './services/AuthService';
import { isAuthenticated } from './store/selectors/AuthSelectors';
import { ToastContainer, toast } from 'react-toastify';

import "./vendor/bootstrap-select/dist/css/bootstrap-select.min.css";
import "./css/style.css";
import ResetPassword from './jsx/pages/ResetPassword';

const SignUp = lazy(() => import('./jsx/pages/Registration'));
const ForgotPassword = lazy(() => import('./jsx/pages/ForgotPassword'));
const Login = lazy(() => new Promise(resolve => setTimeout(() => resolve(import('./jsx/pages/Login')), 500)));

function withRouter(Component) {
 function ComponentWithRouterProp(props) {
 let location = useLocation();
 let navigate = useNavigate();
 let params = useParams();
 return <Component {...props} router={{ location, navigate, params }} />;
 }
 return ComponentWithRouterProp;
}

function App(props) {
 const dispatch = useDispatch();
 const navigate = useNavigate();
 const [authChecked, setAuthChecked] = useState(false);

 useEffect(() => {
 // Run auto-login silently and mark check as completed
 checkAutoLogin(dispatch, navigate)
 .finally(() => setAuthChecked(true));
 }, []);

 // Show preloader until auto-login check is done
 if (!authChecked) {
 return (
 <div id="preloader">
 <div className="sk-three-bounce">
 <div className="sk-child sk-bounce1"></div>
 <div className="sk-child sk-bounce2"></div>
 <div className="sk-child sk-bounce3"></div>
 </div>
 </div>
 );
 }

 const publicRoutes = (
 <Routes>
 <Route path="/" element={<Login />} />
 {/* <Route path="/page-register" element={<SignUp />} /> */}
 <Route path="/forgot-password" element={<ForgotPassword />} />
 <Route path="/reset-password/:token" element={<ResetPassword />} />
 <Route path="*" element={<Navigate to="/" replace />} />
 </Routes>
 );

 return (
 <Suspense
 fallback={
 <div id="preloader">
 <div className="sk-three-bounce">
 <div className="sk-child sk-bounce1"></div>
 <div className="sk-child sk-bounce2"></div>
 <div className="sk-child sk-bounce3"></div>
 </div>
 </div>
 }
 >
 {/* [OK] Toast Container - always available */}
 <ToastContainer
 position="top-right"
 autoClose={2000}
 hideProgressBar={false}
 newestOnTop={false}
 closeOnClick
 rtl={false}
 pauseOnFocusLoss
 draggable
 pauseOnHover
 theme="colored"
 />

 {props.isAuthenticated ? <Index /> : <div className="vh-100">{publicRoutes}</div>}
 </Suspense>
 );
}

const mapStateToProps = (state) => ({
 isAuthenticated: isAuthenticated(state),
});

export default withRouter(connect(mapStateToProps)(App));


